const Constants = {
  PackageNameRegex :new RegExp("\\w+","igm")
};

export default Constants